import { defineMessage } from 'services/localization';

export const messages = {
    accountTargetInternalAccounting: defineMessage('for_my_own_internal_accounting'),
    accountTargetProvideServices: defineMessage('to_provide_services_for_my_clients'),
    connectDescription: defineMessage('create_your_first_appro__new_organisation_later'),
    orSeparatorText: defineMessage('or_1'),
    skipOrganisationCreationButton: defineMessage('skip_organisation_creation_for_now'),
    nextButtonText: defineMessage('next'),
    validationError: defineMessage('please_provide_the_name_of_your_practice'),
    infoTitle: defineMessage('approvalmax_account_setup'),
    infoNavBarTitle: defineMessage('your_business_details'),
    infoAccountPartner: defineMessage('im_going_to_use_this_account'),
    companyCount: defineMessage('how_many_legal_entities__software_do_you_manage'),
    clientCount: defineMessage('for_how_many_clients_ar_ning_to_use_approvalmax'),
    practiceName: defineMessage('please_provide_the_name_of_your_practice'),
    practiceNamePlaceholder: defineMessage('enter_the_practice_name'),
    connectTitle: defineMessage('create_your_first_organisation'),
    connectNavBarTitle: defineMessage('connect_your_accounting_software'),
};
